import { Card, Cores, Divider, Icone, LogoMicroUniverso, NomeIcone } from '@componentes-mu/componentes-mu'


import estiloTelaPrincipal from './styles.module.scss'
import { FlexColumn, FlexRow } from '../../components/Flex'

type HomeProps = {
  handleOnClick: (path: string) => void
}

const Home = ({ handleOnClick }: HomeProps) => {
  const logoEsquerda = (
    <div className={estiloTelaPrincipal.logoEsquerda}>
      <LogoMicroUniverso tipoLogo="largeLogoBlue" Largura="100%" Altura="auto" />
    </div>
  )

  const logoDireita = (
    <div className={estiloTelaPrincipal.logoDireita}>
      <LogoMicroUniverso tipoLogo="MULabelBlue_Slogan" Largura="100%" Altura="auto" />
    </div>
  )

  const cardData: { icon: NomeIcone; description: string; route: string; disabled?: boolean }[] = [
    { icon: 'local_library', description: 'Portal do Conhecimento', route: '/portal-conhecimento/home' },
    { icon: 'add_notes', description: 'Cadastrar Ticket', route: '/cadastrar-ticket' },
    { icon: 'overview', description: 'Tickets', route: '/tickets' },
    { icon: 'new_release', description: 'Versões Liberadas', route: '/versoes-liberadas' },
    {
      icon: 'model_training',
      description: 'Treinamentos Recebidos',
      route: '/treinamentos-recebidos',
    },
    { icon: 'route', description: 'Mapa de Utilização', route: '/mapa-utilizacao', disabled: true },
  ]

  return (
    <div className={estiloTelaPrincipal.principal}>
      <div className={estiloTelaPrincipal.esquerda}>{logoEsquerda}</div>

      <div className={estiloTelaPrincipal.direita}>
        {logoDireita}
        <Divider style={{ width: '100%' }} />


        <FlexColumn>
          <Card
            corDeFundo={Cores.CoresIdentidadeMU.azulEscuroMu}
            style={{
              width: '100%',
              maxWidth: '688px',
              borderRadius: '32px',
              marginTop: '1rem',
            }}>
            <button
              onClick={() => handleOnClick("/portal-conhecimento/reforma-tributaria")}
              className={estiloTelaPrincipal.cardButtonReformaTributaria}
            >
              <FlexRow gap={"1rem"} justifyContent="flex-start">

                <div className={estiloTelaPrincipal.iconWrapper}>
                  <Icone nome={"local_library"}
                    altura="40px"
                    largura="40px"
                    cor={Cores.CoresIdentidadeMU.azulEscuroMu} />
                </div>

                <FlexColumn gap="0.5rem">
                  <div className={estiloTelaPrincipal.cardTituloReformaTributaria}>
                    Reforma Tributária 2026
                  </div>

                  <div className={estiloTelaPrincipal.cardTextoReformaTributaria}>
                    Tudo que você precisa em um só lugar!
                  </div>
                </FlexColumn>
              </FlexRow>

            </button>

          </Card>


          <div className={estiloTelaPrincipal.grid}>

            {cardData.map((card, index) => (
              <Card
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '160px',
                  height: '172px',
                }}
              >
                <button
                  disabled={card.disabled}
                  onClick={() => handleOnClick(card.route)}
                  className={estiloTelaPrincipal.cardButton}
                >
                  <Icone nome={card.icon} altura="96px" largura="96px" cor="#FDFDFD" />
                  <div className={estiloTelaPrincipal.cardTexto}>{card.description}</div>
                </button>
              </Card>
            ))}
          </div>
        </FlexColumn>
      </div>
    </div>
  )
}

export { Home }
